import { defineStore } from "pinia";
import type { User } from "~/api";

export const useAuth = defineStore("auth", {
  state: () => {
    return {
      user: null as User | null,
    };
  },

  getters: {
    loggedIn(state) {
      return Boolean(state.user);
    },
  },
  actions: {
    setUser(user: User | null) {
      this.$patch({ user });
    },
    async refresh() {
      try {
        const api = useApi();
        this.setUser(await api.auth.authGetCurrentUser());
      } catch {
        this.setUser(null);
      }

      return this.user;
    },
  },
});
